import { atom } from "jotai";

export const formInstanceAtom = atom(undefined);
export const tiposDocumentoAtom = atom([]);